import { render, staticRenderFns } from "./hazopImpr.vue?vue&type=template&id=7622f2ec"
import script from "./hazopImpr.vue?vue&type=script&lang=js"
export * from "./hazopImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7622f2ec')) {
      api.createRecord('7622f2ec', component.options)
    } else {
      api.reload('7622f2ec', component.options)
    }
    module.hot.accept("./hazopImpr.vue?vue&type=template&id=7622f2ec", function () {
      api.rerender('7622f2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/risk/hazopImpr.vue"
export default component.exports